import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Toaster from '../Toaster/Toaster.jsx';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button';
import './menubar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useContext, useState, useEffect, useRef, useLayoutEffect } from 'react';
import { LoginContext } from '../../context/loginContext';
import { Link } from 'react-router-dom';
import { getQuestionaireId } from '../personalDetails/personalDetailsService';
import {generateUserPin} from '../../pages/home/homeServices.jsx';
import Modal from 'react-bootstrap/Modal';
import UserPinModal from '../../components/Header/userPinModal.jsx';

// ✅ Dropdown menu (this is added for pale moon browser support)
function CustomDropdownMenu({ title, items, links, onSelect, variant, isOpen, onToggle }) {
    return (
        <div className={`dropdown d-inline-block Primary ${variant}`}>
            <button
                className={`btn btn-${variant.toLowerCase()} dropdown-toggle`}
                type="button"
                onClick={onToggle} // controlled toggle
                id={`dropdown-variants-${variant}`}
            >
                {title}
            </button>
            <ul className={`dropdown-menu palemoon ${isOpen ? "show" : ""}`}>
                {items.map((item, idx) => (
                    <li key={`dropdown-item-${idx}`}>
                        <Button
                            as={Link}
                            to={links[idx]}
                            className="dropdown-item"
                            onClick={() => {
                                onSelect(links[idx]);
                            }}
                        >
                            {item}
                        </Button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

function Menubar({ mobileMenuVisible, handleLogout, setMobileMenuVisible }) {
    const [questionaireName, setQuestionaireName] = useState();
    const [userPin, setUserPin] = useState(null);
    const [showUserPinPopup, setShowUserPinPopup] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);

    const [toastMessage, setToastMessage] = useState('');
     const [toastType, setToastType] = useState('');
     const toastRef = useRef();

     const handleShowToast = (msg, type) => {
         setToastMessage(msg);
         setToastType(type);
         setTimeout(() => {
             const toastElement = toastRef.current;
             const options = {
                 animation: true,
                 autohide: true,
                 delay: 5000,
             };
             if (toastElement) {
                 const bootstrapToast = new bootstrap.Toast(toastElement, options);
                 bootstrapToast.show();
             }
         }, 100);
     };

    const { t, i18n } = useTranslation();
    let {
        loginData: {
            memberDetails,
            alias,
            accessToken,
            refreshMenubar
        },
    } = useContext(LoginContext);

    const currentLang = i18n.language;

    const token_lang = {
        language: currentLang,
        accessToken
    }

    useLayoutEffect(() => {
        setMobileMenuVisible(false);
    }, [location.pathname]);

    useEffect(() => {
        getQuestionaireId(token_lang).then((response) => {
            if (response?.status == 200) {
                const questionaireValue = response?.data?.questionnaireAndIds;
                setQuestionaireName(questionaireValue)
            }
        })
    }, [currentLang, refreshMenubar]);

    const menuList = [
        {
            variant: "Secondary",
            title: t('member.menubar.overview'),
            items: [],
            menuShow: true,
        },
        {
            variant: "Primary",
            title: t('member.menubar.memberShip'),
            menuShow: true,
            items: [
                t('member.menubar.personaldata'),
                t('member.menubar.subscription'),
                t('member.menubar.msgtoGk'),
                t('member.menubar.statistics'),
            ],
            link: [
                '/membership/personaldata',
                '/membership/subcription',
                '/membership/message-to-gleichklang',
                '/membership/statistics'
            ]
        },
        {
            variant: "Success",
            title: t('member.menubar.suggestions'),
            menuShow: true,
            link: [
                '/suggestions/suggestions',
                '/suggestions/lastseen',
                '/suggestions/community-contacts',
                '/suggestions/messenger'
            ],
            items: [
                t('member.menubar.suggestions'),
                t('member.menubar.lastseen'),
                t('member.menubar.communityContacts'),
                t('member.menubar.messages')
            ],
        },
        {
            variant: "Info",
            title: t('member.menubar.personalDetail'),
            menuShow: true,
            link: [
                '/personal-details/community-contacts',
                '/personal-details/social-environement',
                '/personal-details/appearance',
                '/personal-details/overall-personality',
                '/personal-details/hobbies',
                '/personal-details/social-engagement',
                '/personal-details/member-servey',
                '/personal-details/gallery',
                '/personal-details/audios',
            ],
            items: [
                questionaireName?.kontaktliste?.value,
                questionaireName?.person?.value,
                questionaireName?.aussehen?.value,
                questionaireName?.persoenlichkeit?.value,
                questionaireName?.hobby_v?.value,
                questionaireName?.gesellschaft?.value,
                questionaireName?.registration?.value,
                t('member.menubar.galaries'),
                t('member.menubar.audio')
            ],
        },
        {
            variant: "Warning",
            title: t('member.menubar.partnership'),
            menuShow: memberDetails?.partnershipActive,
            link: [
                '/partnership/myprofile',
                '/partnership/what-are-you-looking-for',
                '/partnership/your-thoughts-on-relationship',
                '/partnership/regional-search',
                '/partnership/about-you',
            ],
            items: [
                t('member.menubar.myprofile'),
                questionaireName?.partner?.value,
                questionaireName?.partnerschaft?.value,
                questionaireName?.["partner.region_question"]?.value,
                questionaireName?.ptext?.value,
            ],
        },
        {
            variant: "Danger",
            title: t('member.menubar.friendship'),
            menuShow: memberDetails?.friendshipActive,
            link: [
                '/friendship/myprofile',
                '/friendship/what-are-you-looking-for',
                '/friendship/your-thoughts-on-relationship',
                '/friendship/regional-search',
                '/friendship/about-you',
            ],
            items: [
                t('member.menubar.myprofile'),
                questionaireName?.freund?.value,
                questionaireName?.freundschaft?.value,
                questionaireName?.["friend.region_question"]?.value,
                questionaireName?.ftext?.value
            ]
        },
    ];
    
    const getUserPin = () => {
         generateUserPin(token_lang).then((response) => {
             if (response?.status === 200 && response?.data) {
                 // Success: Set PIN, add history state for back button, and open modal
                 setUserPin(response.data);
                 window.history.pushState({ openModelMobile: true }, '');
                 setShowUserPinPopup(true);
             } else {
                 // Failure: Reset PIN state and do NOT open the modal
                 setUserPin(null);
                 handleShowToast(t('member.header.userPinFetchError'), 'error'); 
             }
         }).catch((error) => {
             // Network or unexpected errors: Reset PIN state and do NOT open modal
             setUserPin(null);
             handleShowToast(t('member.header.userPinFetchError'), 'error');
         });
     }

    const openUserPin = () => {
        getUserPin();
        setMobileMenuVisible(false);
    }

    const closeUserPinPopup = () => {setShowUserPinPopup(false)}
  
    function closeMobileMenu(ref) {
        useEffect(() => {
        function handleClickOutside(event) {
            let toggle_menu = document.getElementById('toggle_menu');
            if (ref.current && !ref.current.contains(event.target) && event.target != toggle_menu) {
                setMobileMenuVisible(false);
            }
        }
        if (mobileMenuVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        }, [ref,mobileMenuVisible]);
    }
    const mobileMenuRef = useRef(null);
    closeMobileMenu(mobileMenuRef);

    //this is added for pale moon browser support to close menu on clicking outside
    useEffect(() => {
        function handleClickOutside(e) {
            // if any menu is open, close it when clicking outside
            if (openMenu !== null) {
                // ignore clicks on dropdown toggles (they already handle toggle)
                if (!e.target.closest(".dropdown")) {
                    setOpenMenu(null);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openMenu]);

    useEffect(() => {
        const handlePopState = () => {
            if (showUserPinPopup) {
                setShowUserPinPopup(false);
            }
        };
        
        window.addEventListener('popstate', handlePopState);
        
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [showUserPinPopup]);

    function isPale() {
        return navigator.userAgent.includes("PaleMoon");
    }


    return (
        <>
        <nav ref={mobileMenuRef} className={mobileMenuVisible ? `menubar_container mobile_nav_show ${isPale() && "isPaleMoonMobile"}` : "menubar_container"}>
        {menuList.map((menu) => (
            menu.menuShow && (
                <div key={menu.variant}>
                    {menu.items.length > 0 ? (                        
                        isPale() ?                              //conditional rendering for pale moon browser
                            <CustomDropdownMenu
                                variant={menu.variant}
                                title={menu.title}
                                items={menu.items}
                                links={menu.link}
                                isOpen={openMenu === menu.variant} // ✅ check if this menu is open
                                onToggle={() =>
                                    setOpenMenu(openMenu === menu.variant ? null : menu.variant) // ✅ toggle logic
                                }
                                onSelect={() => setOpenMenu(null)}
                            />
                        :
                        <DropdownButton
                            className={menu.variant}
                            as={ButtonGroup}
                            key={menu.variant}
                            id={`dropdown-variants-${menu.variant}`}
                            variant={menu.variant.toLowerCase()}
                            title={menu.title}
                        >
                            {menu.items.map((item, index) => (
                                <Dropdown.Item
                                    key={`menulist-item-${index}`}
                                    as={Link}
                                    to={menu?.link?.[index]}
                                >
                                    {item}
                                </Dropdown.Item>
                            ))}
                        </DropdownButton>
                    ) : (
                        <>
                        <div className="mobileNavHeader">
                            {memberDetails ?
						    <button  
                                type="button"
                                style={{ background: "none", border: "none"}}
                                aria-label={`${t('member.header.hello')} ${alias}`}
                                className='greeting' 
                                onClick={() => openUserPin()} 
                            >
                                {t('member.header.hello')} {alias}
                            </button>
                            : null
                            }
                            <Button
                                as={Link}
                                to="/home"
                                className='overview_btn'
                                variant={menu.variant.toLowerCase()}
                                key={menu.variant}>
                                {menu.title}
                            </Button>
                        </div>
                        {mobileMenuVisible &&(
                            <button
                                onClick={(e) => { handleLogout(e); setMobileMenuVisible(false); }}
                                className='logout_btn'
                                aria-label="Logout">
                                <FontAwesomeIcon icon={faSignOutAlt} />
                            </button>
                        )}
                        </>
                        
                    )}
                </div>
            )
        ))}
        <UserPinModal
            showUserPinModal={showUserPinPopup}
            alias={alias}
            closeUserPinPopup={closeUserPinPopup}
            userPin={userPin}
        />
    </nav>
    <div className="nav_placeholder"></div>
    <Toaster toastMessage={toastMessage} toastRef={toastRef} type={toastType}/>   
    </>    
    );
}

export default Menubar;